import { Container } from 'react-bootstrap';
import './sectionHeading.css';

function SectionHeading(props) {
  const { heading, colorHeading, icon, link } = props;

  return (
    <section className="findTheBestHealthCare">
      <Container>
        <div className="section-heading">
          <div>
            <h2>
              {heading || ''}
              <span>{colorHeading || ''}</span>
            </h2>
          </div>
          <div className="border_line" />
          <div className="btn_icon_box">
            {/* dynamic icon */}
            {icon || ''}
            {/* dynamic link */}
            {link || ''}
          </div>
        </div>
      </Container>
    </section>
  );
}
export default SectionHeading;
